import script from "./ResearchReferences.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchReferences.vue?vue&type=script&setup=true&lang=js"

import "./ResearchReferences.vue?vue&type=style&index=0&id=226585d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226585d8"]])

export default __exports__